import React from "react";
import styled from "styled-components";

import ControlPanel from "../Panels/ControlPanel/ControlPanel";
import OutputPanel from "../Panels/OutputPanel/OutputPanel";

const StyledSidebar = styled.div`
  padding: 1vh 0;
`;

const Sidebar = (props) => {
  return (
    <StyledSidebar>
      <ControlPanel
        totalDonations={props.totalDonations}
        payment={props.payment}
        setPayment={props.setPayment}
        forestLat={props.forestLat}
        setForestLat={props.setForestLat}
        forestLng={props.forestLng}
        setForestLng={props.setForestLng}
        treesPlanted={props.treesPlanted}
      />
      {/* <OutputPanel payment={props.payment} /> */}
    </StyledSidebar>
  );
};

export default Sidebar;
